import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20flatlay%20of%20fashionable%20streetwear%20items%20including%20colorful%20sneakers%20denim%20jackets%20canvas%20tote%20bags%20and%20sunglasses%20arranged%20on%20textured%20natural%20linen%20fabric%20with%20dried%20pampas%20grass%20soft%20diffused%20natural%20light%20warm%20earthy%20palette%20editorial%20fashion%20photography%20harmonious%20composition&width=1600&height=900&seq=hero-bg-2026-v3&orientation=landscape"
          alt="Superbuy Sheet product discovery and shopping resources"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 py-20 md:py-0">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left content */}
          <div className="text-white">
            <span className="inline-block px-4 py-1.5 mb-6 text-xs font-semibold tracking-wider uppercase rounded-full border border-white/30 bg-white/10 backdrop-blur-sm">
              Shop Smarter
            </span>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold leading-tight tracking-tight">
              Find Products Faster{' '}
              <span className="text-accent-300">With Organized</span>{' '}
              Shopping Resources
            </h1>
            <p className="mt-5 text-base md:text-lg text-white/80 leading-relaxed max-w-lg">
              Discover updated product collections, category guides and shopping resources created for smarter international shopping.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-start gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-accent-500 text-background-50 font-semibold text-sm rounded-full hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                superbuy sheet
                <i className="ri-arrow-right-line"></i>
              </a>
              <Link
                to="/article/superbuy-sheet-complete-guide"
                className="inline-flex items-center gap-2 px-7 py-3.5 border border-white/40 text-white font-medium text-sm rounded-full hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                Read the Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          {/* Right - trust badges */}
          <div className="hidden lg:flex items-center justify-center">
            <div className="grid grid-cols-2 gap-4 w-full max-w-sm">
              {[
                { num: '14', label: 'Product Categories' },
                { num: '60+', label: 'Shopping Guides' },
                { num: '100+', label: 'Updated Resources' },
                { num: '24/7', label: 'Available Online' },
              ].map((item) => (
                <div key={item.label} className="bg-white/10 backdrop-blur-md rounded-xl p-5 text-center border border-white/15">
                  <div className="font-heading text-3xl font-bold text-accent-300">{item.num}</div>
                  <div className="mt-1 text-xs text-white/70">{item.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Category quick links strip */}
      <div className="absolute bottom-0 left-0 right-0 bg-background-50/80 backdrop-blur-md border-t border-background-200/40">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-3 flex items-center gap-2 overflow-x-auto whitespace-nowrap scrollbar-hide">
          <span className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mr-2">Quick Links:</span>
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs text-foreground-600 bg-background-100 hover:bg-accent-100 hover:text-accent-700 rounded-full transition-colors flex-shrink-0 cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={`${cat.icon} text-xs`}></i>
              </span>
              {cat.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}